export const DEFAULT_POPULATED_CONTACT_PROPERTY_NAMES = ['firstname', 'lastname', 'email', 'company'];
export const DEFAULT_POPULATED_COMPANY_PROPERTY_NAMES = ['name'];
export const CONTACT_PROPERTY_TOKENS = {
  company: {
    sanitized: '{{ contact.company }}',
    isCustom: false,
    name: 'company',
    label: 'Company name'
  }
};